
import en from './en';
import zh from './zh';
import jp from './jp';


import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'
import jaJP from 'vxe-table/lib/locale/lang/ja-JP'

export default {
    zh: {
        ...zh,...zhCN
    },
    en: {
        ...en,...enUS
    },
    jp: {
        ...jp,...jaJP
    }
}
